// @flow

import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';

import { styles } from './styles';

type Props = {
    classes: Object,
    className?: Object,
    size: string,
    text: string,
    circularProgressColorBlue: boolean,
}

const Loader = withStyles(styles)(({ classes, size, text='Sending request...', className, circularProgressColorBlue=false, ...props }: Props): any => {
    function getSize(): Object {
        switch (size) {
            case 'medium':
                return classes.sizeMedium;
            case 'big':
                return classes.sizeBig;
            case 'small':
            default:
                return classes.sizeSmall;
        }
    }

    return (
        <Grid
            item
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={3}
            className={className}
            {...props}
        >
            <CircularProgress className={classNames(getSize(), circularProgressColorBlue && classes.blueColor)}/>
            <Grid item>
                <Typography variant="subtitle1">
                    {text}
                </Typography>
            </Grid>
        </Grid>
    );
});

export default Loader;
